module.exports = __webpack_public_path__ + "img/100-dni.46f882ea.svg";